import FeatureFlagProps from '../../FeatureFlagProps';

const HideFeature = ({
  children,
  flagsToBeTruthy = [],
  allFeatureFlags = {}
}: FeatureFlagProps): JSX.Element | null => {

  for (const flag of flagsToBeTruthy) {
    if (!allFeatureFlags[flag]) {
      return <>{children}</>;
    }
  }

  return null;
}

export default HideFeature;
